/**
 * Where to go after the next sign-in on this origin: an absolute URL on
 * another SystemDox host, kept in sessionStorage across the hosted round trip.
 * `LoginPage` parks it (`?redirect=`) and `LoginPage › PostLoginRedirect`
 * honours it, re-validated by `safeRedirect`.
 *
 * A step-up's way back is the package's (`SignInAgainButton`, ADR-061
 * Amendment 18), not this key.
 */
export const POST_LOGIN_REDIRECT_KEY = 'systemdox:post-login-redirect';

let leaving = false;

/**
 * Go to another SystemDox host, and say so: every other navigation on this
 * page must then hold still. A `location.replace` started after this one
 * cancels it, which is what `TenantNeutralGate` would do on the app host the
 * moment the sign-in lands (`isLeaving`).
 */
export function leaveFor(url: string): void {
  leaving = true;
  window.location.assign(url);
}

/** True once this page is on its way to another host (`leaveFor`). */
export function isLeaving(): boolean {
  return leaving;
}
